import {Tree} from '@sanity/ui'
import {memo} from 'react'
import {styled} from 'styled-components'

export const TreeNav = memo(styled(Tree)`
  overflow: auto;
  height: 100vh;
`)
